import { Button, Grid } from "@mui/material";
import React, { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { connectLMSApi } from "../../../../api";
import Input from "../../../../components/Input/Input";
import "../../../HomePageOrg/HomePageOrg.scss";
import "../ConnectLMSPage.scss";
import { useConnectLMSConext } from "../Context";

const ConnectionSettingsForm = memo(
  ({ isModal = false, onCloseModal, connection = {} }) => {
    const { t } = useTranslation("translation", {
      keyPrefix: "pages.HomePageOrg.ConnectLMSPage",
    });
    const { reloadPage } = useConnectLMSConext();

    // Manual LTI 1.3 platform details. Prefill from the existing connection so
    // editing keeps prior values.
    const [clientId, setClientId] = useState(connection.client_id || "");
    const [issuer, setIssuer] = useState(connection.platform_url || "");
    const [loginUrl, setLoginUrl] = useState(connection.auth_endpoint || "");
    const [tokenUrl, setTokenUrl] = useState(connection.token_endpoint || "");
    const [keySetUrl, setKeySetUrl] = useState(connection.keyset_url || "");
    const [audience, setAudience] = useState(connection.audience || "");
    const [privateKey, setPrivateKey] = useState(connection.private_key || "");

    const handleClientIdChange = (e) => setClientId(e.target.value);
    const handleIssuerChange = (e) => setIssuer(e.target.value);
    const handleLoginUrlChange = (e) => setLoginUrl(e.target.value);
    const handleTokenUrlChange = (e) => setTokenUrl(e.target.value);
    const handleKeySetUrlChange = (e) => setKeySetUrl(e.target.value);
    const handleAudienceChange = (e) => setAudience(e.target.value);
    const handlePrivateKeyChange = (e) => setPrivateKey(e.target.value);

    const handleSubmit = useCallback(async () => {
      if (!connection.id) {
        toast.error("Missing connection id");
        return;
      }
      if (!clientId || !issuer || !loginUrl || !tokenUrl || !keySetUrl) {
        toast.error(t("connectionSettings.requiredFields"));
        return;
      }
      const payload = {
        data: {
          client_id: clientId,
          platform_url: issuer,
          auth_endpoint: loginUrl,
          token_endpoint: tokenUrl,
          keyset_url: keySetUrl,
          audience,
          private_key: privateKey,
        },
      };
      try {
        const response = await connectLMSApi.updateConnectionLMS(
          connection.id,
          payload
        );
        if (response.status === 200) {
          toast.success(t("connectionSettings.successText"));
          reloadPage?.();
          onCloseModal?.();
        }
      } catch (err) {
        toast.error(
          err?.response?.data?.error?.message || t("connectionSettings.errorText")
        );
      }
    }, [
      connection.id,
      clientId,
      issuer,
      loginUrl,
      tokenUrl,
      keySetUrl,
      audience,
      privateKey,
      reloadPage,
      onCloseModal,
      t,
    ]);

    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} md={`${isModal ? 12 : 7}`}>
            <Input
              type="text"
              label={t("connectionItem.client_id")}
              value={clientId}
              onChange={handleClientIdChange}
            />
          </Grid>

          <Grid item xs={12} md={`${isModal ? 12 : 7}`}>
            <Input
              type="text"
              label={t("connectionSettings.issuer")}
              value={issuer}
              onChange={handleIssuerChange}
            />
          </Grid>

          <Grid item xs={12} md={`${isModal ? 12 : 7}`}>
            <Input
              type="text"
              label={t("connectionSettings.login_url")}
              value={loginUrl}
              onChange={handleLoginUrlChange}
            />
          </Grid>

          <Grid item xs={12} md={`${isModal ? 12 : 7}`}>
            <Input
              type="text"
              label={t("connectionSettings.token_url")}
              value={tokenUrl}
              onChange={handleTokenUrlChange}
            />
          </Grid>

          <Grid item xs={12} md={`${isModal ? 12 : 7}`}>
            <Input
              type="text"
              label={t("connectionSettings.key_set_url")}
              value={keySetUrl}
              onChange={handleKeySetUrlChange}
            />
          </Grid>

          <Grid item xs={12} md={`${isModal ? 12 : 7}`}>
            <Input
              type="text"
              label={t("connectionSettings.audience")}
              value={audience}
              onChange={handleAudienceChange}
            />
          </Grid>

          <Grid item xs={12} md={`${isModal ? 12 : 7}`}>
            <Input
              type="text"
              label={t("connectionSettings.private_key")}
              value={privateKey}
              onChange={handlePrivateKeyChange}
            />
          </Grid>
        </Grid>
        <div className="connection-setting-save-btn">
          <Button
            variant="contained"
            className={`button ${isModal ? "save-btn" : ""}`}
            onClick={handleSubmit}
          >
            {t("save")}
          </Button>
        </div>
      </>
    );
  }
);

export default ConnectionSettingsForm;
